import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GeneralInfoBusinessFormState {
  email: string;
  phone: string;
  vat: string;
  identifier: string;
  mainLanguage: string | undefined;
  additionalLanguages: string[];
  paymentMethods: [];
}

const initialState: GeneralInfoBusinessFormState = {
  email: '',
  phone: '',
  vat: '',
  identifier: '',
  mainLanguage: '',
  additionalLanguages: [],
  paymentMethods: [],
};
export const generalInfoBusinessSlice = createSlice({
  name: 'generalInfoBusiness',
  initialState,
  reducers: {
    setGeneralInfoBusinessStateDefault: () => {
      return { ...initialState };
    },
    submitGeneralInfoBusiness: (state, action: PayloadAction<GeneralInfoBusinessFormState>) => {
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.vat = action.payload.vat;
      state.identifier = action.payload.identifier;
      state.mainLanguage = action.payload.mainLanguage;
      state.additionalLanguages = action.payload.additionalLanguages;
      state.paymentMethods = action.payload.paymentMethods;
    },
  },
});

export const { setGeneralInfoBusinessStateDefault, submitGeneralInfoBusiness } = generalInfoBusinessSlice.actions;

export default generalInfoBusinessSlice.reducer;
